import type { Suggestion } from '../aiSuggestionsPluginType';
import { getAnchorLocalId } from '../ui/utils/getAnchorLocalId';

/** `actionKind` of the suggestions whose result the remix engine generates. */
const SUGGESTED_REMIX_ACTION_KIND = 'SUGGESTED_REMIX';

/** Whether this suggestion is fulfilled by the remix engine rather than by ADF tool calls. */
export function isSuggestedRemix(suggestion: Suggestion): boolean {
	return suggestion.actionKind === SUGGESTED_REMIX_ACTION_KIND;
}

/** Source localIds for a remix: backend-supplied `action.localIds`, else the card's anchor. */
export function getRemixSourceLocalIds(suggestion: Suggestion): string[] {
	if (suggestion.action?.localIds?.length) {
		return suggestion.action.localIds;
	}
	const anchorLocalId = getAnchorLocalId(suggestion);
	return anchorLocalId ? [anchorLocalId] : [];
}
